import React from "react";
import Issue from "./Issue";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as IssueActions from "../actions/IssueActions";

const IssueList = (props) => {
  const customization = props.customization;
  
  return (
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead style={{ backgroundColor: "#3F51B5" }}>
          <TableRow>
            <TableCell style={{ color: "white" }}>Id</TableCell>
            <TableCell style={{ color: "white" }}>Issue Description</TableCell>
            {
              customization.severity
                ? <TableCell style={{ color: "white" }}>Severity</TableCell>
                : null    
            }
            {
              customization.status
                ? <TableCell style={{ color: "white" }}>Status</TableCell>
                : null    
            }
            {
              customization.createdDate
                ? <TableCell style={{ color: "white" }}>Created Date</TableCell>
                : null    
            }
            {
              customization.lastUpdated
                ? <TableCell style={{ color: "white" }}>Last Updated</TableCell>
                : null    
            }
            {
              customization.resolvedDate
                ? <TableCell style={{ color: "white" }}>Resolved Date</TableCell>
                : null    
            }
            {
              customization.lastUpdatedBy
                ? <TableCell style={{ color: "white" }}>Last Updated By</TableCell>
                : null    
            }
            {
              customization.loggedBy
                ? <TableCell style={{ color: "white" }}>Logged By</TableCell>
                : null    
            }
            <TableCell style={{ color: "white" }}>Edit</TableCell>
            <TableCell style={{ color: "white" }}>Delete</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.issues && props.issues.map((issue, index) => (
            <Issue setAlertOpen={props.setAlertOpen} key={issue.id} issue={issue} index={index} customization={customization} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

function mapStateToProps(state) {
  return {
    issues: state.issues,
    users: state.users,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(IssueActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(IssueList));
